import {
  IAppointmentRequest,
  IAppointmentRequestDeposit,
  IEvent,
  IPatientFormData,
  IPrimaryContactFormData,
  IPractice,
  IStaffer,
  ITreatmentTemplateWithStep,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  INamedDocument,
  MockGenerator,
  MockISODate,
} from '@principle-theorem/shared';
import { MockNamedDocument } from '@principle-theorem/testing';
import { EventMock } from '../event/event.mock';
import { TreatmentStepMock } from '../clinical-charting/treatment/treatment-step.mock';
import { TreatmentPlanMock } from '../clinical-charting/treatment/treatment-plan.mock';

export class AppointmentRequestMock extends BaseFirestoreMock<IAppointmentRequest> {
  get event(): IEvent {
    return MockGenerator.generate(EventMock);
  }

  get practitioner(): INamedDocument<IStaffer> {
    return MockNamedDocument<IStaffer>();
  }

  get practice(): INamedDocument<IPractice> {
    return MockNamedDocument<IPractice>();
  }

  get patient(): {
    primaryContact: IPrimaryContactFormData;
    patient?: IPatientFormData;
  } {
    return {
      primaryContact: {
        name: 'John Doe',
        dateOfBirth: MockISODate(),
        email: 'john@example.com',
        mobileNumber: '1234567890',
      },
    };
  }

  get template(): ITreatmentTemplateWithStep {
    return {
      plan: MockGenerator.generate(TreatmentPlanMock),
      step: MockGenerator.generate(TreatmentStepMock),
    };
  }

  get deposit(): IAppointmentRequestDeposit | undefined {
    return;
  }
}
